import React from 'react';
import { Hero } from '../components/home/Hero';
import { QuickFacts } from '../components/home/QuickFacts';
import { UpcomingEvents } from '../components/home/UpcomingEvents';
import { WhoWeAre } from '../components/home/WhoWeAre';
import { Mission } from '../components/home/Mission';
import { FirstThursday } from '../components/home/FirstThursday';
import { PhotoMosaic } from '../components/home/PhotoMosaic';
import { WelcomeVideo } from '../components/home/WelcomeVideo';
import { FinalCta } from '../components/home/FinalCta';
export function Home() {
  return <>
      <Hero data-id="element-531" data-mp="29g4yknincsx5" />
      <QuickFacts data-id="element-532" data-mp="29gdb2eauxw7t" />
      <UpcomingEvents data-id="element-533" data-mp="29fvgdm3ufq20" />
      <WhoWeAre data-id="element-534" data-mp="29ek40xwc19za" />
      <Mission data-id="element-535" data-mp="29i7yq0dik2fl" />
      <FirstThursday data-id="element-536" data-mp="29ihmdhb35xi4" />
      <PhotoMosaic data-id="element-537" data-mp="2di8bzhovm7l2" />
      <WelcomeVideo data-id="element-538" data-mp="2dirsqv2sipxi" />
      <FinalCta data-id="element-539" data-mp="2dj9wsdvp28fz" />
    </>;
}